import { render, staticRenderFns } from "./ChatPrivateSide.vue?vue&type=template&id=12cfb30d&scoped=true"
import script from "./ChatPrivateSide.vue?vue&type=script&lang=js"
export * from "./ChatPrivateSide.vue?vue&type=script&lang=js"
import style0 from "./ChatPrivateSide.vue?vue&type=style&index=0&id=12cfb30d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cfb30d",
  null
  
)

export default component.exports